import { render } from "./networkCounterBox.vue?vue&type=template&id=aed32208&ts=true"
import script from "./networkCounterBox.vue?vue&type=script&lang=ts"
export * from "./networkCounterBox.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__